import React from "react";
import TeamComponent from "../components/Team";
import NavBar from "../components/NavBar";

const Team = () => {
  return (
    <>
      <NavBar id="team" />
      <TeamComponent />
    </>
  );
};

export default Team;
